// Constants for better maintainability
const SCROLL_THRESHOLD = {
    MOBILE: 800,
    DESKTOP: 600
};

function initStickyCart() {
    const stickyElement = document.querySelector('.rq-sticky-add-to-cart-main');
    if (!stickyElement) return;

    // Set initial state
    stickyElement.style.opacity = '0';
    stickyElement.style.transform = 'translateY(100%)';
    stickyElement.style.transition = 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out';
    stickyElement.style.position = 'fixed';
    stickyElement.style.bottom = '0';
    stickyElement.style.left = '0';
    stickyElement.style.right = '0';
    stickyElement.style.zIndex = '100';
    stickyElement.style.display = 'block'; // Ensure it's visible but transformed out of view

    // Simplified scroll handling with throttle
    let ticking = false;
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                const scroll = window.scrollY || document.documentElement.scrollTop;
                const threshold = window.matchMedia('(max-width: 1023px)').matches ? 
                    SCROLL_THRESHOLD.MOBILE : SCROLL_THRESHOLD.DESKTOP;

                if (scroll >= threshold) {
                    showSticky(stickyElement);
                } else {
                    hideSticky(stickyElement);
                }
                ticking = false;
            });
            ticking = true;
        }
    });
}

function showSticky(element) {
    element.style.opacity = '1';
    element.style.transform = 'translateY(0)';
    element.style.pointerEvents = 'auto';
}

function hideSticky(element) {
    element.style.opacity = '0';
    element.style.transform = 'translateY(100%)';
    element.style.pointerEvents = 'none';
}

// Initialize the sticky cart functionality when DOM is ready
document.addEventListener('DOMContentLoaded', initStickyCart);

// Configure button functionality (unchanged)
document.addEventListener('DOMContentLoaded', function() {
    const configureButton = document.querySelector('.rq-sticky-configure');
    if (configureButton) {
        configureButton.addEventListener('click', function(e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            document.querySelectorAll('fieldset.variant-picker__option button.select')
                .forEach(btn => btn.classList.add('rq-configure-selected-variant'));
        });
    }

    document.body.addEventListener('click', function(e) {
        if (e.target.classList.contains('rq-configure-selected-variant')) {
            document.querySelectorAll('fieldset.variant-picker__option button.select')
                .forEach(btn => btn.classList.remove('rq-configure-selected-variant'));
        }
    });
});

// Show More/Less functionality
document.addEventListener('DOMContentLoaded', function() {
    const showMoreButton = document.querySelector('.rq-show-more-text-pdp-img');
    if (showMoreButton) {
        showMoreButton.addEventListener('click', function() {
            const textDiv = this.querySelector('div');
            const svg = this.querySelector('svg');
            const hiddenElements = document.querySelectorAll('.product-gallery__media.rqhide-after');

            if (textDiv.textContent === 'Show more') {
                textDiv.textContent = 'Show less';
                svg.classList.add('rq-rotate');
                hiddenElements.forEach(el => slideDown(el));
            } else {
                textDiv.textContent = 'Show more';
                svg.classList.remove('rq-rotate');
                hiddenElements.forEach(el => slideUp(el));
            }
        });
    }
});

function slideDown(element) {
    element.style.removeProperty('display');
    let display = window.getComputedStyle(element).display;
    if (display === 'none') display = 'block';
    element.style.display = display;
    let height = element.offsetHeight;
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    element.offsetHeight; // Force repaint
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = '500ms';
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, 500);
}

function slideUp(element) {
    let height = element.offsetHeight;
    element.style.transitionProperty = 'height, margin, padding';
    element.style.transitionDuration = '500ms';
    element.style.height = height + 'px';
    element.style.overflow = 'hidden';
    
    // Force repaint
    element.offsetHeight;
    
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
    
    window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
    }, 500);
}
